import React, { useRef, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import loader from 'assets/spinner-white-sm.svg';

import styles from './PasswordSettings.module.scss';
import { sendToApi, sendToApiReturn } from 'API/teacherCalls';
import { defaultUserImg, openInNewTab } from 'helpers/uiFunctions';

const PasswordSettings = () => {

  const dashData = useSelector(state => state.dashData)
  const mainRef = useRef();
  const oldRef = useRef(); 
  const newRef = useRef(); 
  const confRef = useRef(); 
  const btnRef = useRef(); 
  const [error, setError] = useState({visible:false, text:'error message', success:false})
  const [ submit, setSubmit ] = useState({loading:false, response:''})


  const shake = () =>{
    mainRef.current.classList.add(styles.shake)
    setTimeout(()=>{mainRef.current.classList.remove(styles.shake)},1000)
  }


  useEffect(()=>{

    if(submit.response==='error'){
      shake()
      setError({visible:true, text:'Incorrect password'})
      oldRef.current.value=''
      oldRef.current.focus()
      newRef.current.value=''
      confRef.current.value=''
      
    } else if (submit.response==='success'){
      setError({visible:false, success:true})
      btnRef.current.classList.add(styles.revert)
      setTimeout(()=>{btnRef.current.classList.remove(styles.revert)},1000)
      oldRef.current.value=''
      oldRef.current.focus()
      newRef.current.value=''
      confRef.current.value=''
    }
  },[submit])


  const handleSubmit = async () => {
    
    const oldPass = oldRef.current.value;
    const newPass = newRef.current.value;
    const confPass = confRef.current.value;


    if(oldRef.current.value===''||newRef.current.value===''||confRef.current.value===''){
      setError({visible:true, text:'Please complete all fields'})
      shake()

    } else if (newRef.current.value.length<6){
      setError({visible:true, text:'Password must be at least 6 characters'})
      shake()

    } else if (newRef.current.value !== confRef.current.value){
      setError({visible:true, text:'Passwords do not match'})
      shake()

    } else {
      setError({...error, visible:false})
      setSubmit({loading:true, response:''})
      btnRef.current.classList.add(styles.revert)
      setTimeout(()=>{btnRef.current.classList.remove(styles.revert)},1500)
      const payload = {
        existing_password:oldPass,
        new_password: newPass,
        confirm_password:confPass
      }

      const res = await sendToApiReturn(`account/change_password`, payload)
      setSubmit({...submit, response:res.message.message})


      }
  }

  return (
    <div className={styles.container}>
      <Link to='/teacher/classes'> <div className={styles.back}> {'< Go to dashboard'}</div> </Link>
      {
        dashData.name ? 
        <>
          <div className={styles.header}>
            <img src={ defaultUserImg({imageUrl:dashData.imageUrl}) } alt="user profile pic"/>
            <div className={styles.text}>
              <div className={styles.title}>
                <h4>{dashData.name}</h4>
                <p>/</p>
                <h4>Password</h4>
              </div>
              <p>Manage or create a new password</p>
            </div>
          </div>

          <div ref={mainRef} className={styles.main}>

            <div className={styles.row}>
              <h3>Old password</h3>
              <input autoFocus ref={oldRef} type="password" name="oldPassword" id="oldPassword"/>
              {/* @todo update forgot password link */}
              <p onClick={()=>{openInNewTab('https://account.boomwriter.com/educator/forgot')}}>Forgotten password?</p>
            </div>

            <div className={styles.row}>
              <h3>New password</h3>
              <input ref={newRef} type="password" minLength={6} name="newPassword" id="newPassword"/>
              <p>Minimum 6 characters</p>
            </div>

            <div className={styles.row}>
              <h3>Confirm new password</h3>
              <input ref={confRef} type="password" minLength={6} name="confNew" id="confNew"/>
            </div>

            
            <div className={(error.visible ? styles.error : `${styles.error} ${styles.hidden}`)}> {error.text} </div>
            <div className={(error.success ? styles.success : `${styles.success} ${styles.hidden}`)}> Password successfuly changed! </div>

          </div>
          {
            submit.response==='success' ? 
              <Link to='/teacher/classes'> <div ref={btnRef} className={styles.button}>Go to dashboard</div> </Link> 
            :
              <div ref={btnRef} onClick={handleSubmit} className={styles.button}> {!submit.loading ? 'Confirm' : <img src={loader} alt="loader"/> }</div>
          }
        </>
        :
        <>
          <h2>No user information found</h2>
          <p>Please log in to your Escribli account in oder to perform this operation</p>
        </>
      }
    </div>
  )

}

export default PasswordSettings;